import script from "./MultipurposeImageBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipurposeImageBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MultipurposeImageBanner.vue?vue&type=style&index=0&id=3885de5b&lang=scss"

const __exports__ = script;

export default __exports__